import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { SupersetAction } from './superset.action';
import { supersetInitialState } from './superset.constant';

export const supersetReducer = reducerWithInitialState(supersetInitialState)
  .case(SupersetAction.loadChartMetadata.started, (state, { sliceId }) => {
    const existing = state.chartMetadata[sliceId];

    return {
      ...state,
      chartMetadata: {
        ...state.chartMetadata,
        [sliceId]: {
          ...existing,
          networkStatus: NetworkStatus.Started,
        },
      },
    };
  })
  .case(SupersetAction.loadChartMetadata.done, (state, { params, result }) => ({
    ...state,
    chartMetadata: {
      ...state.chartMetadata,
      [params.sliceId]: {
        ...result,
        networkStatus: NetworkStatus.Done,
      },
    },
  }))
  .case(SupersetAction.loadChartMetadata.failed, (state, { params }) => {
    const existing = state.chartMetadata[params.sliceId];

    return {
      ...state,
      chartMetadata: {
        ...state.chartMetadata,
        [params.sliceId]: {
          ...existing,
          networkStatus: NetworkStatus.Failed,
        },
      },
    };
  })
  .case(SupersetAction.updateColumnsMetadata, (state, { sliceId, columns }) => {
    const existing = state.chartMetadata[sliceId];

    return {
      ...state,
      chartMetadata: {
        ...state.chartMetadata,
        [sliceId]: {
          ...existing,
          columns,
        },
      },
    };
  })
  .case(SupersetAction.loadRowCount, (state, { sliceId, totalRowCount, filteredRowCount }) => {
    const existing = state.chartMetadata[sliceId];

    return {
      ...state,
      chartMetadata: {
        ...state.chartMetadata,
        [sliceId]: {
          ...existing,
          totalRowCount,
          filteredRowCount,
        },
      },
    };
  })
  .case(SupersetAction.loadChartList.started, (state) => ({
    ...state,
    chartList: {
      ...state.chartList,
      networkStatus: NetworkStatus.Started,
    },
  }))
  .case(SupersetAction.loadChartList.done, (state, { result }) => ({
    ...state,
    chartList: {
      items: result,
      networkStatus: NetworkStatus.Done,
    },
  }))
  .case(SupersetAction.loadChartList.failed, (state) => ({
    ...state,
    chartList: {
      ...state.chartList,
      networkStatus: NetworkStatus.Failed,
    },
  }));
